import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { KpiResultPeriod } from '@masar/common/models';
import { KpiMeasurementCycleType } from '@masar/common/types';

@Component({
    selector: 'app-kpi-result-attachment-dialog',
    templateUrl: './period-capability-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PeriodCapabilityDialogComponent {
    @Input() public periods: KpiResultPeriod[];
    @Input() public measurementCycle: KpiMeasurementCycleType;
}
